import React, { PureComponent } from 'react'
import { Provider } from 'react-redux'
import Store from '../../store'
import timelineContainer from '../containers/timeline-redux-container'
import { fetchTimelineConfig, fetchUserTimelineVisibility } from '../actions/timeline'
import _ from 'lodash'

type TimelineStore = {
    timelineConfig: {
        disabled: boolean,
        mode: string
    },
    userTimelineVisible: boolean
}

type Props = {
    span: string,
    dashboardId: number,
    containerWidth: number,
    updateSpan: Function,

    // STORE
    error?: string,
    setTimelineConfig: Function,
    getTimelineConfig: Function,
    getUserTimelineVisibility: Function
} & TimelineStore

type TimelineProviderState = {} & TimelineStore

const provider = (component, visibleAtBegin) =>
    class TimelineProvider extends PureComponent<Props, TimelineProviderState> {

        TimelineContainer: Object

        constructor (props: Props) {
            super(props)
            this.props = props
            this.TimelineContainer = timelineContainer(component)

            const storeState = Store.getState()

            this.state = {
                timelineConfig: storeState.timeline.timelineConfig,
                userTimelineVisible: storeState.timeline.userTimelineVisible
            }
        }

        componentDidMount () {
            this.mounted = true

            Store.subscribe(() => {
                const timelineStoreState = Store.getState().timeline

                const stateObj = {
                    timelineConfig: timelineStoreState.timelineConfig,
                    userTimelineVisible: timelineStoreState.userTimelineVisible
                }

                if (!_.isEqual(stateObj, this.state) && this.mounted) this.setState(stateObj)
            })

            let dispatcher = Store.dispatch

            // Updating timelineConfig in store
            dispatcher(fetchTimelineConfig(this.props.dashboardId))

            // Updating userTimelineVisibility in store
            dispatcher(fetchUserTimelineVisibility(this.props.dashboardId))
        }

        componentWillUnmount () {
            this.mounted = false
        }

        render () {
            let TimelineContainer = this.TimelineContainer

            const { timelineConfig, userTimelineVisible } = this.state
            const { disabled } = timelineConfig
            const timelineVisible = !disabled && userTimelineVisible

            return (
                <Provider store={Store}>
                    <TimelineContainer {...this.props} isVisible={visibleAtBegin || timelineVisible} />
                </Provider>
            )
        }

    }

export default provider
